export default __webpack_public_path__ + "static/media/calendarImg.1350b45e.webp";